module.exports = {
      id: "paywalliconbenefit-usage",
      viewBox: "0 0 33.788 14.247",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#paywalliconbenefit",
      toString: function () {
        return this.url;
      }
    }